import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Typography } from "@mui/material";

import { UIActionModal, UITextarea } from "../../../../ui";

const RejectRequestModal = ({ open, applicants, copy, onClose, onReject }) => {
  const [reason, setReason] = useState("");
  const isBulk = applicants.length > 1;

  useEffect(() => {
    if (!open) return;
    setReason("");
  }, [open]);

  const message = isBulk
    ? copy.bulkMessage.replace("{count}", applicants.length)
    : "";

  return (
    <UIActionModal
      open={open}
      onClose={onClose}
      title={copy.title}
      variant="reject"
      maxWidth="sm"
      PaperProps={{ className: "event-applicants-reject-modal" }}
      actions={
        <UIActionModal.Actions
          cancelLabel={copy.cancel}
          confirmLabel={copy.reject}
          confirmVariant="reject"
          onCancel={onClose}
          onConfirm={() => onReject({ reason })}
        />
      }
    >
      {isBulk ? (
        <Typography className="event-applicants-reject-modal__message">
          {message}
        </Typography>
      ) : null}
      <UIActionModal.Divider />
      <Typography className="ui-action-modal__body-text">
        {copy.hint}
      </Typography>
      <UITextarea
        label={copy.reasonLabel}
        name="rejectionReason"
        value={reason}
        placeholder={copy.placeholder}
        onValueChange={setReason}
        minRows={3}
        classNames={{ root: "event-applicants-reject-modal__field" }}
      />
    </UIActionModal>
  );
};

RejectRequestModal.propTypes = {
  open: PropTypes.bool.isRequired,
  applicants: PropTypes.arrayOf(PropTypes.object),
  copy: PropTypes.shape({
    title: PropTypes.string.isRequired,
    bulkMessage: PropTypes.string.isRequired,
    hint: PropTypes.string.isRequired,
    reasonLabel: PropTypes.string.isRequired,
    placeholder: PropTypes.string.isRequired,
    cancel: PropTypes.string.isRequired,
    reject: PropTypes.string.isRequired,
  }).isRequired,
  onClose: PropTypes.func.isRequired,
  onReject: PropTypes.func.isRequired,
};

RejectRequestModal.defaultProps = {
  applicants: [],
};

export default RejectRequestModal;
